import styled from 'styled-components'

import { HELVETICA } from './styles'


// Global styles
// injectGlobal`
// `

const RootContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  ${HELVETICA}
`

export default RootContainer



// WEBPACK FOOTER //
// ./src/components/RootContainer.js